import {
    FETCH_ORDERS_FAILURE,
    FETCH_ORDERS_REQUEST,
    FETCH_ORDERS_SUCCESS,
    MARK_PRODUCT_WITHDRAWN,
    POST_ORDERS_FAILURE,
    POST_ORDERS_REQUEST,
    POST_ORDERS_SUCCESS,
} from '../../actionTypes';
import { FAILURE, FETCHING, SUCCESS } from '../../fetchStatus';

const initialState = null;

function patchProductOrderStatus(orders, orderId, productId, orderStatus) {
    const patchProduct = product =>
        String(product?._id) === String(productId) ? { ...product, orderStatus } : product;

    return orders.map(order => {
        if (String(order._id) !== String(orderId)) return order;

        const cartProducts = (order.cart?.products ?? []).map(patchProduct);

        const productsByLieferweg = {};
        if (order.productsByLieferweg) {
            for (const [key, products] of Object.entries(order.productsByLieferweg)) {
                productsByLieferweg[key] = products.map(patchProduct);
            }
        }

        return {
            ...order,
            cart: { ...order.cart, products: cartProducts },
            productsByLieferweg,
        };
    });
}

export default function orders(state = initialState, action) {
    switch (action.type) {
        case FETCH_ORDERS_REQUEST:
        case POST_ORDERS_REQUEST:
            return {
                ...state,
                status: FETCHING,
            };
        case MARK_PRODUCT_WITHDRAWN: {
            const { orderId, productId } = action.payload;
            if (!state?.data) return state;
            return {
                ...state,
                data: patchProductOrderStatus(state.data, orderId, productId, 'initiated'),
            };
        }
        case FETCH_ORDERS_SUCCESS:
        case POST_ORDERS_SUCCESS:
            return {
                status: SUCCESS,
                data: action.payload.orders,
            };
        case FETCH_ORDERS_FAILURE:
        case POST_ORDERS_FAILURE:
            return {
                status: FAILURE,
                error: action.payload.error,
            };
        default:
            return state;
    }
}
